
<template>
  <div class="inner">
    <div class="row">
      <div class="col-12-small col-6">
        <div class="capsule">
        	<h3>Hey! Come on in, you transit mover & shaker!</h3>
        	<form v-on:submit.prevent="validateBeforeSubmit">
	        	<div class="form-group text-left">
	        		<label class="custom-label control=label">Enter the secret password</label>
	        		<input class="form-control password-field" type="password" name="password" v-model.trim="password">
	        		<span class="error help-block" ></span>
	        	</div><br />
	        	<div class="text-danger" v-if="error"><p>Incorrect password.</p></div>
	        	<button class="button primary" type="submit">GO!</button>
	        </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import storageHelper from 'storage-helper'
export default {
	data() {
		return {
			error: null,
			password: null
		}
	},
	methods: {
		validateBeforeSubmit() {
			if (this.password === 'GoTransit2020!') {
				this.error = false
				storageHelper.setItem('password', this.password)
				this.$router.push('/')

			} else {
				this.error = true
			}
		}
	}
}
</script>


